import React, { useEffect, useState } from "react";
import pClasses from "../Test.module.scss";
import * as iTest from "../../../interfaces/InterfacesTest";
import { useTranslation } from "react-i18next";
import ButtonsArea from "../../Buttons/ButtonsArea";
import RoundButton from "../../Buttons/RoundButton";
import Spinner from "../../Spinner";
import Steppers from "../../Steppers";
import ButtonsAreaContent from "./ButtonsAreaContent";
import { useGlobalContext } from "../TestsContext/GlobalStateContext";
import AlertDialogSquare from "../../AlertDialogSquare";
import SquareButton from "../../Buttons/SquareButton/SquareButton";

interface TestAreaInterface {
  test: iTest.InterfacesTest | null;
  activeTest: string;
  volume: number;
  testTime: number;
  setResultsGrandfather: (newValue: any) => void | null;
  setScoreLevel: (newValue: number) => void | null;
  setTestLevelFinal: (newValue: number) => void | null;
  onClick: () => void | null;
}

export default function TestArea({
  test = null as iTest.InterfacesTest | null,
  activeTest,
  volume,
  testTime,
  setResultsGrandfather,
  setScoreLevel,
  setTestLevelFinal,
  onClick,
}: TestAreaInterface) {
  const { t } = useTranslation();
  const [hasConfirmed, setHasConfirmed] = useState(false);
  const [isPlayingAudio, setIsPlayingAudio] = useState(false);
  const [hasPlayedAudio, setHasPlayedAudio] = useState(false);
  const [confirmButtonAbleAux, setConfirmButtonAbleAux] = useState(false);
  const [isLastOneAux, setIsLastOneAux] = useState(false);
  const [testLevel, setTestLevel] = useState(0);
  const [resultsFather, setResultsFather] = useState(0);
  const [blanckAnswers, setBlanckAnswers] = useState(0);
  const [btnClicked, setBtnClicked] = useState(false);
  const [scoreRTTempHandler, setScoreRTTempHandler] = useState([] as any);
  const { score, setScore, arrayAnswers, arrayCorrects } = useGlobalContext();
  const isResolucaoTemporal = String(activeTest) === "resolucao_temporal";

  //Pontuation of dicotico sequencial (1/2)
  // useEffect(() => {
  //   if (activeTest === 'dicotico_sequencial') {
  //     const corrects = String(String(Object.values(arrayCorrects)).split('_')).split(',');
  //     const answers = Object.values(arrayAnswers)
  //     if (testLevel) [answers[testLevel - 1]].forEach((answer: any) => {
  //       let cont = 0;
  //       if (answer) answer.forEach((ans: any) => {
  //         if (arrayCorrects) if ((Object.values(arrayCorrects))) {
  //           if (corrects.indexOf(ans.split('_')[1]) > -1) {
  //             cont++;
  //             if (cont === 4) {
  //               setScore(score + cont)
  //             }
  //             if (cont === 3) {
  //               setScore(score + cont)
  //             }
  //             if (cont === 2) {
  //               setScore(score + cont)
  //             }
  //             if (cont === 1) {
  //               setScore(score + cont)
  //             }
  //           }
  //         }
  //       })
  //     })
  //   }
  // }, [testLevel, arrayAnswers]);

  let howManyQuestions = 1;
  if (activeTest === "resolucao_temporal") howManyQuestions = 5;

  let _content = <Spinner center />;
  let _steppers = null;

  const nextLevelHandler = () => {
    setIsPlayingAudio(false);
    setHasConfirmed(false);
    setHasPlayedAudio(false);
    setTestLevel(testLevel + 1);
    window.scrollTo(0, 0);
  };
  const nextLevelHandlerAlert = () => {
    setIsPlayingAudio(false);
    setHasConfirmed(false);
    setHasPlayedAudio(false);
    setTestLevel(testLevel + 1);
    setBlanckAnswers(blanckAnswers + 1);
    window.scrollTo(0, 0);
  };

  const submitTestHandler = () => {
    onClick();
    window.scrollTo(0, 0);
    !isResolucaoTemporal
      ? setTestLevelFinal(testLevel + 1)
      : setTestLevelFinal((testLevel + 1) * howManyQuestions);
  };

  const { levels, setup, multi_options, list_options, levels_text } =
    test as iTest.InterfacesTest;
  if (
    levels &&
    levels_text &&
    levels[testLevel] &&
    setup &&
    (multi_options || list_options)
  ) {
    const { correct } = levels[testLevel] as iTest.InterfacesLevel;
    if (correct) {
      // TODO apenas pra tirar o warning
    }

    if (isResolucaoTemporal) howManyQuestions = 5;
    if (!isResolucaoTemporal) howManyQuestions = 1;

    const _btnPropsArrayRender = [];
    for (let i = 0; i < howManyQuestions; i++) {
      const levelTextAuxRender = testLevel * howManyQuestions + i;
      _btnPropsArrayRender[i] = (
        <ButtonsAreaContent
          // key={h.keyGenerator(levelTextAuxRender)}
          test={test}
          activeTest={activeTest}
          volume={volume}
          btnClicked={btnClicked}
          setBtnClicked={setBtnClicked}
          testLevel={levelTextAuxRender}
          setResultsSon={setResultsFather}
          setConfirmButtonAbleAux={setConfirmButtonAbleAux}
          setIsLastOneAux={setIsLastOneAux}
          setScoreRT={setScoreRTTempHandler}
          levelTextAuxRender={levelTextAuxRender}
        />
      );
    }

    !isResolucaoTemporal
      ? setResultsGrandfather(resultsFather)
      : setResultsGrandfather(resultsFather);
    const stepsNumberAux = levels.map((el, index) => index + 1);
    const half = Math.ceil(stepsNumberAux.length / howManyQuestions);
    const firstHalf = stepsNumberAux.slice(0, half);
    _steppers = (
      <Steppers
        stage={testLevel + 1}
        checkAll
        steppes={firstHalf}
        showLabels={false}
        horizontal
      />
    );
    let isButtonNextLevelAbble = true;
    if (Object.keys(arrayAnswers).length >= 1 + testLevel * howManyQuestions)
      isButtonNextLevelAbble = false;
    let isButtonNextLevelAbbleResolucao = true;
    if (Object.keys(arrayAnswers).length > testLevel)
      isButtonNextLevelAbbleResolucao = false;
    let isButtonNextLevelAbbleDicoticoSequencial = true;
    let isShowAlertDicoticoSequencial = true;
    if (Object.values(arrayCorrects).length - 1 === testLevel)
      isButtonNextLevelAbbleDicoticoSequencial = false;
    let isButtonNextLevelCompleteAbble = true;
    if (Object.keys(arrayAnswers).length >= howManyQuestions)
      isButtonNextLevelCompleteAbble = false;
    const auxArrayAnswerOrdTemp: any = Object.values(arrayAnswers)[testLevel];
    let cont = 0;
    if (auxArrayAnswerOrdTemp) {
      cont = auxArrayAnswerOrdTemp.length;
    }
    if (Object.values(arrayCorrects)) {
      if (
        String(Object.values(arrayAnswers)[testLevel]).split(",").length < 4 &&
        String(Object.values(arrayCorrects).length)
      ) {
        isShowAlertDicoticoSequencial = true;
      } else {
        isShowAlertDicoticoSequencial = false;
      }
    }
    _content = (
      <>
        {_steppers}
        {activeTest === "ordenacao_temporal" && testLevel < 5 && (
          <>Orelha Esquerda</>
        )}
        {activeTest === "ordenacao_temporal" && testLevel >= 5 && (
          <>Orelha Direita</>
        )}
        <ButtonsArea>
          {isResolucaoTemporal && _btnPropsArrayRender}
          {!isResolucaoTemporal && _btnPropsArrayRender}
        </ButtonsArea>
        <ButtonsArea spacer>
          {activeTest !== "resolucao_temporal" &&
            activeTest !== "ordenacao_temporal" &&
            !(
              activeTest === "dicoticos_od" ||
              activeTest === "dicoticos_oe" ||
              activeTest === "dicotico_sequencial"
            ) && (
              <div className={pClasses.ContentFixedButton}>
                <SquareButton
                  center
                  disabled={isButtonNextLevelAbble}
                  title={t("global.confirm")}
                  text={t("global.confirm")}
                  onClick={isLastOneAux ? submitTestHandler : nextLevelHandler}
                />
              </div>
            )}
          {activeTest === "dicotico_sequencial" && (
            <>
              <div className={pClasses.ContentFixedButton}>
                {isShowAlertDicoticoSequencial ? (
                  <AlertDialogSquare
                    textButton={t("global.confirm")}
                    textDialogPrimary={t("Respostas em branco!")}
                    textDialogSecondary={t(
                      "Ainda existem perguntas não respondidas! Deseja continuar?"
                    )}
                    buttonDesabled={isButtonNextLevelAbbleDicoticoSequencial}
                    onConfirm={
                      isLastOneAux ? submitTestHandler : nextLevelHandlerAlert
                    }
                  />
                ) : (
                  <RoundButton
                    center
                    disabled={isButtonNextLevelAbbleDicoticoSequencial}
                    title={t("global.confirm")}
                    text={t("global.confirm")}
                    onClick={
                      isLastOneAux ? submitTestHandler : nextLevelHandler
                    }
                  />
                )}
              </div>
            </>
          )}
          {!hasConfirmed && activeTest === "resolucao_temporal" && (
            <>
              <div className={pClasses.ContentFixedButton}>
                {Object.keys(arrayAnswers).filter((value) => {
                  return (Number(value) + 1) % 5 === 0;
                }).length !== 0 &&
                Object.keys(arrayAnswers).filter((value) => {
                  return (Number(value) + 1) % 5 === 0;
                }).length ===
                  testLevel + 1 - blanckAnswers ? (
                  <SquareButton
                    center
                    disabled={false}
                    title={t("global.confirm")}
                    text={t("global.confirm")}
                    onClick={
                      isLastOneAux ? submitTestHandler : nextLevelHandler
                    }
                  />
                ) : (
                  <AlertDialogSquare
                    textButton={t("global.confirm")}
                    textDialogPrimary={t("Respostas em branco!")}
                    textDialogSecondary={t(
                      "Ainda existem perguntas não respondidas! Deseja continuar?"
                    )}
                    buttonDesabled={isButtonNextLevelAbbleResolucao}
                    onConfirm={
                      isLastOneAux ? submitTestHandler : nextLevelHandlerAlert
                    }
                  />
                )}
              </div>
            </>
          )}
          {!hasConfirmed && activeTest === "ordenacao_temporal" && (
            <>
              <div className={pClasses.ContentFixedButton}>
                {cont === 3 && (
                  <SquareButton
                    center
                    disabled={isButtonNextLevelCompleteAbble}
                    title={t("global.confirm")}
                    text={t("global.confirm")}
                    onClick={
                      isLastOneAux ? submitTestHandler : nextLevelHandler
                    }
                  />
                )}
                {!(cont === 3) && (
                  <AlertDialogSquare
                    textButton={t("global.confirm")}
                    textDialogPrimary={t("Respostas em branco!")}
                    textDialogSecondary={t(
                      "Ainda existem perguntas não respondidas! Deseja continuar?"
                    )}
                    buttonDesabled={isButtonNextLevelAbble}
                    onConfirm={
                      isLastOneAux ? submitTestHandler : nextLevelHandler
                    }
                  />
                )}
              </div>
            </>
          )}
          {!hasConfirmed &&
            (activeTest === "dicoticos_od" ||
              activeTest === "dicoticos_oe") && (
              <>
                <div className={pClasses.ContentFixedButton}>
                  {cont === 2 && (
                    <SquareButton
                      center
                      disabled={isButtonNextLevelCompleteAbble}
                      title={t("global.confirm")}
                      text={t("global.confirm")}
                      onClick={
                        isLastOneAux ? submitTestHandler : nextLevelHandler
                      }
                    />
                  )}
                  {!(cont === 2) && (
                    <AlertDialogSquare
                      textButton={t("global.confirm")}
                      textDialogPrimary={t("Respostas em branco!")}
                      textDialogSecondary={t(
                        "Ainda existem perguntas não respondidas! Deseja continuar?"
                      )}
                      buttonDesabled={isButtonNextLevelAbble}
                      onConfirm={
                        isLastOneAux ? submitTestHandler : nextLevelHandler
                      }
                    />
                  )}
                </div>
              </>
            )}
        </ButtonsArea>
      </>
    );
  }
  return <div className={pClasses.TestArea}>{_content}</div>;
}
